<template><div><h1 id="_8-telefonmarketing-alnovis" tabindex="-1"><a class="header-anchor" href="#_8-telefonmarketing-alnovis"><span>8. Telefonmarketing (Alnovis)</span></a></h1>
<p>Für den Datenaustausch zwischen der Telefonmarketing-Agentur (aktuell wird Alnovis unterstützt) bietet funtrade eine Schnittstelle für den Export und Import der Daten.</p>
<h3 id="_8-1-parametrisierung" tabindex="-1"><a class="header-anchor" href="#_8-1-parametrisierung"><span>8.1. Parametrisierung</span></a></h3>
<p>Die Parametrisierung erfolgt anhand der Definition in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tm-alnovis-param.html">Telefonmarketing (Alnovis) Parametrisierung</RouteLink> und dem Systemparameter TmAlnovis-Schnittstelle in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.sysparam.html">Systemparameter</RouteLink> .</p>
<h3 id="_8-2-beschreibung-des-ablaufs" tabindex="-1"><a class="header-anchor" href="#_8-2-beschreibung-des-ablaufs"><span>8.2. Beschreibung des Ablaufs</span></a></h3>
<p>Der Export der Daten erfolgt mittels einer vorgängig definierten Segmentierung, sprich die zu exportierenden Daten (Personen) werden in einer Segmentierung selektiert und im Exportprozess als Quelle verwendet.</p>
<p>Die exportierten Daten werden direkt zur Telefonmarketing-Agentur hochgeladen und dort verarbeitet (abtelefoniert).</p>
<p>Die gewonnenen Responses werden durch die Telefonmarketing-Agentur für das Zurücklesen ins funtrade in einer definierten Form bereitgestellt.</p>
<p>Die bereitgestellten Daten können durch funtrade abgeholt und direkt eingelesen werden.</p>
<p><strong>Prozedur 8.8. Daten exportieren</strong></p>
<ol>
<li>
<p>Segmentierung definieren</p>
<p>Für den Export der Daten muss vorgängig eine Segmentierung definiert werden.</p>
</li>
<li>
<p>Segmentierung markieren</p>
<p>Die definierte Segmentierung muss für den Export vorher markiert sein.</p>
</li>
<li>
<p>Job für Export der Daten starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.tmalnovisexportieren.html" title="Alnovis - Segmentierungsdatei exportieren...">Alnovis - Segmentierungsdatei exportieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Segmentierung auswählen</p>
<p>Vorgängig definierte Segmentierung auswählen</p>
</li>
<li>
<p>Daten exportieren</p>
<p>Mit OK werden die in der Segmentierung enthaltenen Adressen zur Telefonmarketing-Agentur exportiert.</p>
</li>
</ol>
<p><strong>Prozedur 8.9. Daten importieren</strong></p>
<ol>
<li>
<p>Job für Import der Daten starten</p>
<p>Aus dem Kontextmenu <RouteLink to="/referenz/refs/ft.refproc.tmalnovisimportieren.html" title="Alnovis - Datei importieren...">Alnovis - Datei importieren...</RouteLink> wählen.</p>
</li>
<li>
<p>Daten importieren</p>
<p>Mit OK werden die Daten abgeholt und auch gleich verarbeitet, das Abholen der Daten ohne eine Verarbeitung wird auch unterstützt.</p>
</li>
</ol>
<h3 id="_8-3-siehe-auch" tabindex="-1"><a class="header-anchor" href="#_8-3-siehe-auch"><span>8.3. Siehe auch</span></a></h3>
<p><RouteLink to="/referenz/refs/ft.refdata.tm-alnovis-param.html" title="Telefonmarketing (Alnovis) Parametrisierung">Telefonmarketing (Alnovis) Parametrisierung</RouteLink></p>
<p><RouteLink to="/referenz/refs/ft.refdata.tm-alnovis.html" title="Telefonmarketing (Alnovis) Export/Import">Telefonmarketing (Alnovis) Export/Import</RouteLink></p>
<p><RouteLink to="/referenz/refs/ft.refproc.tmalnovisexportieren.html" title="Alnovis - Segmentierungsdatei exportieren...">Alnovis - Segmentierungsdatei exportieren...</RouteLink></p>
<p><RouteLink to="/referenz/refs/ft.refproc.tmalnovisimportieren.html" title="Alnovis - Datei importieren...">Alnovis - Datei importieren...</RouteLink></p>
</div></template>


